import moment from "moment";
import {
  BUTTON_INITIATE_CLAIM,
  CANCELLED_POLICIES_STATUS_IDS,
  DAMAGED_ASSET_PARTS_LIST,
  DAMAGED_CYCLE_PARTS_SLUG,
  DAMAGE_DETAILS_SLUG,
  DATE_OF_DAMAGE_SLUG,
  DEALER_OTP_LENGTH,
  DEFAULT_CITY_NAME,
  DEFAULT_PINCODE,
  DEFAULT_STATE_NAME,
  DOCUMENT_CDN_PATH,
  ERROR_MESSAGE_TEXT,
  FORMAT_DOB,
  FORMAT_YYYY_MM_DD_HMS,
  GB_SLUG,
  LOCATION_OF_DAMAGE_SLUG,
  MOBILE_OTSR_PRODUCT_ID,
  MOBILE_ADLD_PRODUCT_ID,
  MOBILE_EW_PRODUCT_ID,
  MOBILE_PRODUCT_IDS,
  PAYMENT_FAILED_MESSAGE,
  PREFERRED_DATE,
  DAMAGE_DATE,
  PREFERRED_TIMESLOT,
  COPAYMENT_NOT_APPLICABLE_PRODUCTS,
  COPAYMENT_PRODUCTS,
  USER,
  USER_DETAILS_SLUG,
} from "../constants";
import {
  DAMAGE_DETAIL_MIN_CHAR_LENGTH,
  FIELDS_HAVING_ALPHABET_AND_SPACE_ONLY,
  FIXED_LENGTH_FIELDS,
  ONLY_ALPHA_NUMERIC_FIELDS,
  ONLY_ALPHA_NUMERIC_SPACE_FIELDS,
  ONLY_DIGIT_FIELDS,
} from "../constants/field";
import { getStorageItem } from "./utils";
import { Utils } from "../constants/utils";
import { productClaimType, sectionTitle } from "../mapping";
import { getCurrentDate } from "./date";
import { boolean } from "yup";

export const buildGeneratePaymentLinkPayload = (entity_id) => {
  return {
    entity: "claim",
    entity_id,
    is_monthly: false,
    is_recurring: false,
    payment_method: false,
    payment_type: "CLAIM_COPAY",
  };
};

export const buildLoginPayload = ({ mobile }) => {
  return {
    mobile: Number(mobile),
    otp_length: DEALER_OTP_LENGTH,
    type: USER,
  };
};

export const buildRazorpayResponseErrorMessage = () => {
  return {
    data: {
      error_msg: PAYMENT_FAILED_MESSAGE,
    },
  };
};

export const buildResendOtpPayload = ({ email, mobile, name }) => {
  const payload = buildLoginPayload({ mobile });

  return { ...payload, email, name };
};

export const buildSubmitOtpPayload = ({ mobile, otp }) => {
  return {
    mobile,
    otp,
    type: USER,
  };
};

export const buildSystemErrorMessage = () => {
  return {
    data: {
      error_msg: ERROR_MESSAGE_TEXT,
    },
  };
};

export const buildServiceCentreUrl = (params) =>
  `service_centres?${new URLSearchParams(params).toString()}`;

export const calulateOnRoadPrice = (finalBreakUp) => {
  let onRoadPrice = 0;

  finalBreakUp.forEach((item) => {
    onRoadPrice += Number(item.amount);
  });

  return onRoadPrice;
};

export const convertToInteger = (value) => (value ? parseInt(value) : null);

export const getSectionTitle = (str) =>
  sectionTitle[removeTrailingBackslash(removeDigits(str))] ??
  BUTTON_INITIATE_CLAIM;

export const isOnlyAlphaNumericField = (fieldName) =>
  ONLY_ALPHA_NUMERIC_FIELDS.indexOf(fieldName) > -1;

export const isOnlyAlphaNumericSpaceField = (fieldName) =>
  ONLY_ALPHA_NUMERIC_SPACE_FIELDS.indexOf(fieldName) > -1;

export const isOnlyDigitField = (fieldName) =>
  ONLY_DIGIT_FIELDS.indexOf(fieldName) > -1;

export const isFixedLengthField = (fieldName) =>
  FIXED_LENGTH_FIELDS.indexOf(fieldName) > -1;

export const isInitiateClaimButtonDisabled = (
  fieldName,
  start_date,
  end_date
) => {
  if (!isSevenDaysPassed(new Date(start_date), fieldName === 92 ? 365 : 7)) {
    return true;
  }
  return MOBILE_PRODUCT_IDS.indexOf(fieldName) === -1;
};

// Method to check if 7 days have passed since the start date
const isSevenDaysPassed = (startDate, days = 7) => {
  const currentDate = new Date(); // Current date
  const timeDifference = currentDate.getTime() - startDate.getTime(); // Difference in milliseconds
  const millisecondsInADay = 1000 * 3600 * 24; // Number of milliseconds in a day

  // Convert milliseconds to days
  const daysDifference = timeDifference / millisecondsInADay;

  return daysDifference >= days;
};

export const isDaysPassed = (dateString, daysToAdd = 7) => {
  const startDate = new Date(dateString);
  startDate.setDate(startDate.getDate() + daysToAdd);
  return startDate;
};

export const isLoginNextButton = ({ mobile, hasError }, errorMessage, term) =>
  !mobile || (mobile && errorMessage.mobile) || hasError || term;

export const isPolicyCancelled = (fieldName) =>
  CANCELLED_POLICIES_STATUS_IDS.indexOf(fieldName) > -1;

export const isPlanExpired = (expiredDate, serverTimeStamp) => {
  const end = new Date(expiredDate);
  const current = new Date(serverTimeStamp);
  const timeDifference = current - end;
  const dayDifference = timeDifference / (1000 * 3600 * 24);
  return dayDifference < 1;
};

export const isSubmitButtonDisabled = (
  form,
  errorMessage,
  orderDetails,
  photo,
  isFormSubmitted
) => {
  return (
    isFormSubmitted ||
    !orderDetails ||
    // !photo?.phone ||
    !form?.damage_details ||
    form.damage_details.length < DAMAGE_DETAIL_MIN_CHAR_LENGTH ||
    !form.state_id ||
    !form.city_id ||
    !form.service_centre_id ||
    !form.preferred_date ||
    !form.damage_date ||
    // !form.preferred_timeslot ||
    errorMessage?.damage_details ||
    errorMessage?.preferred_date ||
    errorMessage?.damage_date

  );
};

export const removeDigits = (str) => str.replace(/[0-9]/g, "");

export const removeTrailingBackslash = (str) => str.replace(/\/$/, "");

export const validateInputLength = (event) => {
  const elName = event.target.name;
  let elValue = event.target.value;

  if (FIELDS_HAVING_ALPHABET_AND_SPACE_ONLY.indexOf(elName) > -1) {
    elValue = elValue.replace(/(\s{2,})|[^a-zA-Z']/g, " ");
    elValue = elValue.replace(/^\s*/, "");
    event.target.value = elValue;
  }

  if (isOnlyDigitField(elName)) {
    event.target.value = elValue.replace(/[^0-9]+/g, "");
  }

  if (isOnlyAlphaNumericField(elName)) {
    event.target.value = elValue.replace(/[^0-9A-Za-z]+/g, "").toUpperCase();
  }

  if (isOnlyAlphaNumericSpaceField(elName)) {
    event.target.value = elValue.replace(/[^0-9A-Za-z\s]+/g, "").toUpperCase();
  }

  if (elValue.length > Utils.limit.digits[elName]) {
    event.target.value = elValue.substring(0, Utils.limit.digits[elName]);
  }
};

export const syncProposalDetails = ({
  name = null,
  email = null,
  // mobile,
  pincode = null,
  city = null,
  state = null,
  address_line_1 = null,
  address_line_2,
  response_phone_brand: phone_brand = null,
  response_phone_model: phone_model = null,
  response_phone_color: phone_color = null,
  response_phone_storage: phone_storage = null,
  response_phone_ram: phone_ram = null,
  response_screen_photo: screen_photo = null,
  response_imei_number: imei_number = null,
  response_manufactured_date: manufactured_date = null,
  response_serial_number: serial_number = null,
  product_name = null,
  response_coverage_period: coverage_period = null,
  start_date = null,
  end_date = null,
  response_invoice_amount: invoice_amount = null,
  response_invoice_number: invoice_number = null,
  response_invoice_date: invoice_date = null,
  response_invoice: invoice = null,
  policy_document = null,
  policy_number = null,
  toffee_id = null,
  on_road_price = null,
} = {}) => {
  const splittedScreenPhoto = screen_photo ? screen_photo.split("/") : [];
  const screenLength = splittedScreenPhoto.length;
  const screen_photo_name = screenLength
    ? splittedScreenPhoto[screenLength - 1]
    : null;
  const screen_photo_link = screen_photo
    ? `${DOCUMENT_CDN_PATH}${screen_photo}`
    : null;

  const splittedInvoicePhoto = invoice ? invoice.split("/") : [];
  const invoiceLength = splittedInvoicePhoto.length;
  const invoice_name = invoiceLength
    ? splittedInvoicePhoto[invoiceLength - 1]
    : null;
  const invoice_link = invoice ? `${DOCUMENT_CDN_PATH}${invoice}` : null;

  const splittedPolicyDocument = policy_document
    ? policy_document.split("/")
    : [];
  const documentLength = splittedPolicyDocument.length;
  const policy_document_name = documentLength
    ? splittedPolicyDocument[documentLength - 1]
    : null;

  return {
    name,
    email,

    pincode,
    city,
    state,
    address: address_line_1,

    phone_brand,
    phone_model,
    phone_color,
    phone_storage: phone_storage ? `${phone_storage} ${GB_SLUG}` : null,
    phone_ram: phone_ram ? `${phone_ram} ${GB_SLUG}` : null,
    screen_photo,
    screen_photo_name,
    screen_photo_link,

    imei_number,
    manufactured_date,
    serial_number,
    product_name,
    coverage_period,
    start_date: start_date ? moment(start_date).format(FORMAT_DOB) : "",
    end_date: end_date ? moment(end_date).format(FORMAT_DOB) : "",
    invoice_amount,
    invoice_number,
    invoice_date,
    invoice,
    invoice_name,
    invoice_link,

    policy_document,
    policy_document_name,
    policy_number,
    toffee_id,
    on_road_price,
    ex_showroom_price: invoice_amount,
  };
};

export const toSentenceCase = (string) =>
  string.charAt(0).toUpperCase() + string.slice(1);

export const toTitleCase = (str) => {
  return str
    .replaceAll("_", " ")
    .toLowerCase()
    .replace(/\b\w/g, (s) => s.toUpperCase());
};

export const buildInitiateClaimPayload = (product_id, {
  city = DEFAULT_CITY_NAME,
  state = DEFAULT_STATE_NAME,
  pincode = DEFAULT_PINCODE,
  damage_details = "",
  preferred_date = "",
  preferred_timeslot = "",
  damage_date = "",
  service_centre_id = "",
}) => {
  return {
    claim_type_id: [productClaimType[product_id]],
    service_centre_id,
    inputs: [
      {
        name: DATE_OF_DAMAGE_SLUG,
        value: getCurrentDate().format(FORMAT_YYYY_MM_DD_HMS),
      },
      {
        name: LOCATION_OF_DAMAGE_SLUG,
        value: {
          city,
          state,
          pincode,
        },
      },
      {
        name: DAMAGE_DETAILS_SLUG,
        value: damage_details,
      },
      {
        name: DAMAGED_CYCLE_PARTS_SLUG,
        value: DAMAGED_ASSET_PARTS_LIST,
      },
      {
        name: PREFERRED_DATE,
        value: preferred_date,
      },
      {
        name: PREFERRED_TIMESLOT,
        value: preferred_timeslot,
      },
      {
        name: DAMAGE_DATE,
        value: damage_date,
      },
    ],
  };
};

export const buildSubmitClaimInput = () => {
  return {
    skip_copayment: isSkipCopayment(),
  };
};

export const getCustomerName = () =>
  getStorageItem(USER_DETAILS_SLUG) &&
  JSON.parse(getStorageItem(USER_DETAILS_SLUG)).name;

export const isSkipCopayment = () => {
  return false;
  // Commented this code since skip_copayment is not relevant now.
  // return localStorage.getItem("skip_copayment") === "true";
};

export const isCopaymentRequired = (productId) =>
  COPAYMENT_PRODUCTS.indexOf(productId) > -1 && !isSkipCopayment();

export const isLoginViaMasterOtp = () =>
  localStorage.getItem("master_otp_login") === "true";

export const isLoginViaMasterOtpUser = () =>
  localStorage.getItem("master_otp_user") === "service_centre";

export const syncPolicyTermsAndConditionVisibility = (list) => {
  let tndc = {
    [MOBILE_OTSR_PRODUCT_ID]: false,
    [MOBILE_ADLD_PRODUCT_ID]: false,
    [MOBILE_EW_PRODUCT_ID]: false,
  };

  list.map((item) => {
    tndc[item.product_id] = true;
  });

  return tndc;
};

// validate form input
export const validateInputsLength = (value) => (value?.length > 0 && value?.length < DAMAGE_DETAIL_MIN_CHAR_LENGTH) ? 1 :0;
